// scheduler/clock.ts
export interface TransportClock {
  t0Audio: number; // ctx.currentTime anchor
  t0Media: number; // media seconds at that moment
  rate: number;    // effective playback rate
  // internal: last audio time used for slew correction (optional)
  _slewLastAudioNow?: number;
}

export const mediaTimeAt = (clk: TransportClock, audioNow: number) =>
  clk.t0Media + (audioNow - clk.t0Audio) * clk.rate;

/**
 * Slew-limit the clock towards an observed media time, avoiding hard snaps.
 * maxMsPerSec controls the maximum correction rate (e.g., 2–5 ms/s).
 */
export function applySlew(
  clk: TransportClock,
  audioNow: number,
  observedMediaNow: number,
  opts?: { maxMsPerSec?: number }
) {
  const predicted = mediaTimeAt(clk, audioNow);
  const errSec = (observedMediaNow - predicted);
  const last = clk._slewLastAudioNow ?? audioNow;
  const dt = Math.max(1 / 48000, audioNow - last); // >= one sample
  const maxMsPerSec = opts?.maxMsPerSec ?? 3; // default 3 ms per second
  const limitSec = (maxMsPerSec / 1000) * dt;
  const corr = Math.max(-limitSec, Math.min(limitSec, errSec));
  // apply small offset to t0Media in direction of observed timeline
  clk.t0Media += corr;
  clk._slewLastAudioNow = audioNow;
}
